<template>
  <div class="repairs">
    <v-container fluid>
      <template>
        <v-card class="d-flex-column justify-space-between ma-2">
          <v-card-title>
            <h1 class="mr-2 subheading grey--text">Επισκευές</h1>
            <v-spacer/>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>
          <v-data-table :headers="showHeaders" :items="repairs"
          :search="search"
          loading: false
          item-key="Id"
          class="elevation-1"
          :items-per-page=15
          show-group-by
          :height="$vuetify.breakpoint.height*0.6"
          :loading="loading" loading-text="Loading... Please wait"
          @click:row="clickrow" >


          <template v-slot:item.Vehicle.VehType="{ item }">
            <span v-if="!item.Vehicle.VehType">-</span>
            <span v-else>
             <v-icon>{{$vehicleBadges[item.Vehicle.VehType]}}</v-icon>
             <span v-if="$vuetify.breakpoint.mdAndUp">  {{ item.Vehicle.VehType }}</span>
            </span>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="showHeaders.length">More info about {{ item.Id }}</td>
            {{ item.Notes }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
              :to="{name: 'edit-repair', params: {repairId: item.Id}}"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <new-repair :VehId="item.Id" useIcon="true"/>
          </template>
          <template v-slot:item.empty="{ item }">
            <v-btn
              class="mr-2"
              icon
              small
            >
              <v-icon v-if="item.RepairCost==0">mdi-basket-outline</v-icon>
              <v-icon v-else>mdi-basket</v-icon>
            </v-btn>
          </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="dialog=true">Reset</v-btn>
        </template>
        </v-data-table>
        </v-card>
      </template>
    </v-container>
  </div>
</template>

<script>
import NewRepair from "../components/NewRepair.vue"

export default {

  components: {
    NewRepair
  },
  computed: {
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(["Id","Vehicle.Vin",]).includes(h.value));
        } else {
            return this.headers;
        }
    },
  },
  data() {
    return {
      menu: false,
      repairs: [],
      dialog: false,
      loading: true,
      balance: 0.0,
      search: "",

      headers: [
        {
          text: "Α/A",
          align: "start",
          //sortable: false,
          value: "Id",
          width: "5%",
        },
        { text: 'Ημ/νία', value: 'Date'},
        {
          text: "Αρ. Κυκλοφορίας",
          align: "start",
          //sortable: false,
          value: "Vehicle.PlateNumber",
          width: "10%",
        },
        { text: "VIN", value: "Vehicle.Vin" },
        { text: "Τύπος", value: "Vehicle.VehType"},
        { text: "Πελάτης", value: "Vehicle.Owner.Name" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "Em", value: "empty", sortable: false },
        { text: '', value: 'data-table-expand' },
      ],
    };
  },
  async created() {
    // GET request using fetch with async/await
    try {
      await this.fetchRepairs();

    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    clickrow(item, _) {
      //this.$router.push('distributor/'+item.distributor_id)
    },
    async fetchRepairs() {
      this.loading = true;
      const response = await this.$api.get("/repairs/");
      this.repairs = response.data;

      this.loading = false;
    },
    getColor(status) {
      if (status === "complete") return "green";
      else if (status === "overdue") return "red";
      else return "";
    },
  },
};
</script>

<style>
.project.complete {
  border-left: 4px solid #3cd1c2;
}
.project.ongoing {
  border-left: 4px solid #ffaa2c;
}
.project.overdue {
  border-left: 4px solid #f83e70;
}
.v-chip.complete {
  background: #3cd1c2;
}
.v-chip.ongoing {
  background: #ffaa2c;
}
.v-chip.overdue {
  background: #f83e70;
}

.toupper input {
  text-transform: uppercase;
}
</style>
